<template>
  <nav class="navbar navbar-expand-lg navbar-themed">
    <div class="container">
      <!-- <a class="navbar-brand" href="/">King of Bots</a> -->
      <router-link class="navbar-brand" :to="{ name: 'home' }">智能对抗系统</router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
        aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarText">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link :class="route_name == 'pk_home' ? 'nav-link active' : 'nav-link'" :to="{ name: 'pk_home' }">
              <img class="nav-icon" src="@/assets/svg_icons/对战.svg" alt="">
              PK对战
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :class="is_training_route ? 'nav-link active' : 'nav-link'" :to="{ name: 'training_index' }">
              <img class="nav-icon" src="@/assets/svg_icons/lightbulb.svg" alt="">
              训练模式
            </router-link>
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="/record/">对局列表</a> -->
            <router-link :class="route_name == 'record_index' ? 'nav-link active' : 'nav-link'"
              :to="{ name: 'record_index' }">
              <img class="nav-icon" src="@/assets/svg_icons/列表.svg" alt="">
              对局列表
            </router-link>
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="/ranklist/">排行榜</a> -->
            <router-link :class="route_name == 'ranklist_index' ? 'nav-link active' : 'nav-link'"
              :to="{ name: 'ranklist_index' }">
              <img class="nav-icon" src="@/assets/svg_icons/排行榜.svg" alt="">
              排行榜
            </router-link>
          </li>

          <li class="nav-item" v-if="!$store.state.user.is_login">
            <router-link class="nav-link" :to="{ name: 'user_account_login' }">
              <img class="nav-icon" src="@/assets/svg_icons/聊天室.svg" alt="">
              聊天室
            </router-link>
          </li>
          <li class="nav-item" v-else>
            <router-link :class="route_name == 'talkroom' ? 'nav-link active' : 'nav-link'"
              :to="{ name: 'talkroom', params: { userId: $store.state.user.id } }">
              <img class="nav-icon" src="@/assets/svg_icons/聊天室.svg" alt="">
              聊天室
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :class="route_name == 'chatgpt' ? 'nav-link active' : 'nav-link'" :to="{ name: 'chatgpt' }">
              <img class="nav-icon" src="@/assets/svg_icons/Chatgpt.svg" alt="">
              AI对话
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :class="route_name == 'comment' ? 'nav-link active' : 'nav-link'" :to="{ name: 'comment' }">
              <img class="nav-icon" src="@/assets/svg_icons/comment.svg" alt="">
              意见栏
            </router-link>
          </li>
        </ul>

        <ul class="navbar-nav user-nav" v-if="$store.state.user.is_login">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle user-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="user-avatar-wrap">
            <img class="user-avatar" :src="avatarSrc" alt="user avatar" @error="useDefaultAvatar">
          </span>
          {{ $store.state.user.username }}
        </a>
        <ul class="dropdown-menu dropdown-theme">
              <li>
                <!-- <a class="dropdown-item" href="/user/bot">我的Bot</a> -->
                <router-link class="dropdown-item" :to="{ name: 'user_bot_index' }">
                  <img class="nav-icon" src="@/assets/svg_icons/bx-bot.svg" alt="">
                  我的Bot
                </router-link>
              </li>

              <li>
                <router-link class="dropdown-item"
                  :to="{ name: 'userprofile', params: { userId: $store.state.user.id } }">
                  <img class="nav-icon" src="@/assets/svg_icons/myspace.svg" alt="">
                  我的空间
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" :to="{ name: 'userlist_index' }">
                  <img class="nav-icon" src="@/assets/svg_icons/userlist.svg" alt="">
                  好友列表
                </router-link>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <router-link class="dropdown-item" :to="{ name: 'profilesettings' }">
                  <img class="nav-icon" src="@/assets/svg_icons/setting.svg" alt="">
                  设置
                </router-link>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="#" @click="logout">
                  <img class="nav-icon" src="@/assets/svg_icons/exit.svg" alt="">
                  退出
                </a></li>
            </ul>
          </li>
        </ul>

        <ul class="navbar-nav user-nav" v-else-if="!$store.state.user.pulling_info">
          <li class="nav-item ">
            <router-link class="nav-link" :to="{ name: 'user_account_login' }" role="button">
              登录
            </router-link>
          </li>
          <li class="nav-item ">
            <router-link class="nav-link" :to="{ name: 'user_account_register' }" role="button">
              注册
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';
import defaultAvatar from '@/assets/images/visitor.png';

export default {
  name: 'NavBar',
  setup() {
    const route = useRoute();
    let route_name = computed(() => route.name);
    const is_training_route = computed(() => String(route.name || "").startsWith("training_"));

    const store = useStore();
    const avatarSrc = computed(() => store.state.user.photo || defaultAvatar);
    const logout = () => {
      store.dispatch("logout");
    }

    const useDefaultAvatar = event => {
      event.target.src = defaultAvatar;
    };

    return {
      route_name,
      is_training_route,
      avatarSrc,
      useDefaultAvatar,
      logout,
    }
  }
}
</script>

<style scoped>
.navbar-themed {
  position: sticky;
  top: 0;
  z-index: 1500;
  width: min(1180px, calc(100% - 24px));
  margin: 0 auto;
  background: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow-soft);
  border: 1px solid var(--app-border);
  border-radius: 14px;
  backdrop-filter: blur(18px);
  overflow: visible;
}

:global(:root[data-theme="dark"]) .navbar-themed,
:global(body[data-theme="dark"]) .navbar-themed {
  top: 0;
  margin-top: 0;
  border-top-color: rgba(255, 255, 255, 0.08);
  border-radius: 0 0 14px 14px;
}

.navbar-themed .container {
  position: relative;
  max-width: 1120px;
  padding-right: 150px;
  min-height: 56px;
}

.navbar-themed .navbar-collapse {
  gap: 12px;
  min-width: 0;
}

.navbar-themed .navbar-nav {
  align-items: center;
}

.navbar-themed .navbar-nav.me-auto {
  flex-wrap: wrap;
  row-gap: 4px;
}

.navbar-themed .user-nav {
  position: absolute;
  top: 50%;
  right: 12px;
  margin-left: 0;
  flex-shrink: 0;
  transform: translateY(-50%);
  z-index: 2;
  display: flex;
  align-items: center;
}

.navbar-themed .navbar-brand,
.navbar-themed .nav-link {
  color: var(--app-text);
  font-weight: 700;
  letter-spacing: 0;
}

.navbar-themed .navbar-brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--app-text);
}

.navbar-themed .nav-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  border-radius: 10px;
  padding: 8px 10px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.user-toggle {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  min-width: max-content;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.user-toggle:hover,
.user-toggle:focus {
  background: var(--app-surface-muted);
}

.navbar-themed .nav-link .nav-icon,
.dropdown-theme .dropdown-item .nav-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  opacity: 1;
  padding: 5px;
  border-radius: 9px;
  background: var(--nav-icon-bg);
  filter: var(--nav-icon-filter);
  transition: filter 0.2s ease, opacity 0.2s ease, background-color 0.2s ease;
}

.navbar-themed .nav-link.active,
.navbar-themed .nav-link:focus,
.navbar-themed .nav-link:hover {
  background: rgba(20, 184, 166, 0.14);
  color: var(--app-primary);
}

.navbar-themed .nav-link.active .nav-icon,
.navbar-themed .nav-link:focus .nav-icon,
.navbar-themed .nav-link:hover .nav-icon,
.dropdown-theme .dropdown-item:hover .nav-icon,
.dropdown-theme .dropdown-item:focus .nav-icon {
  opacity: 1;
  background: var(--nav-icon-active-bg);
  filter: var(--nav-icon-active-filter);
}

.navbar-themed .navbar-toggler {
  border-color: var(--app-border);
  border-radius: 10px;
}

:global(:root[data-theme="light"]) .navbar-themed .navbar-toggler-icon,
:global(body[data-theme="light"]) .navbar-themed .navbar-toggler-icon {
  filter: none;
}

:global(:root[data-theme="dark"]) .navbar-themed .navbar-toggler-icon,
:global(body[data-theme="dark"]) .navbar-themed .navbar-toggler-icon {
  filter: invert(1);
}

.user-avatar-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  min-width: 28px;
  max-width: 28px;
  overflow: hidden;
  border: 2px solid rgba(20, 184, 166, 0.45);
  border-radius: 50%;
  background: var(--app-surface-strong);
}

.user-avatar-wrap .user-avatar {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  background: transparent !important;
  filter: none !important;
  opacity: 1;
  object-fit: cover;
  border-radius: 50%;
}

.dropdown-theme {
  background: var(--app-surface);
  color: var(--app-text);
  border: 1px solid var(--app-border);
  border-radius: 12px;
  box-shadow: var(--app-shadow-soft);
  padding: 8px;
}

.dropdown-theme .dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--app-text);
  border-radius: 9px;
  padding: 8px 10px;
  font-weight: 600;
}

.dropdown-theme .dropdown-item:hover {
  background: rgba(20, 184, 166, 0.14);
  color: var(--app-primary);
}

.dropdown-divider {
  border-color: var(--app-border);
}

@media (max-width: 991px) {
  .navbar-themed {
    top: 0;
    width: calc(100% - 16px);
    margin-top: 0;
  }

  :global(:root[data-theme="dark"]) .navbar-themed,
  :global(body[data-theme="dark"]) .navbar-themed {
    top: 0;
    margin-top: 0;
  }

  .navbar-themed .nav-link {
    width: 100%;
  }

  .navbar-themed .container {
    padding-right: 12px;
  }

  .navbar-themed .user-nav {
    position: static;
    width: 100%;
    margin-top: 8px;
    transform: none;
  }
}
</style>
